import { mentionLabelsInBody } from "@/lib/mention-handle-validation"
import { mentionHandleGroupsPath } from "@/routes"
import type { MentionHandleGroup } from "@/types"

export default function MentionSummary({
  body,
  mentionHandleGroups = [],
}: {
  body: string
  mentionHandleGroups?: MentionHandleGroup[]
}) {
  const mappedLabels = new Set(mentionHandleGroups.map((group) => group.label))
  const unmapped = mentionLabelsInBody(body).filter(
    (label) => !mappedLabels.has(label),
  )

  if (unmapped.length === 0) return null

  return (
    <p className="text-sm text-amber-600">
      No handle mapping for: {unmapped.map((m) => `@${m}`).join(", ")}.{" "}
      <a href={mentionHandleGroupsPath()} className="underline">
        Configure Mentions
      </a>
    </p>
  )
}
